import { getLocale } from '../helpers.js';
/**
 * function: formatCurrency
 * Pattern: NumberFormat
 * Example: € 123,45
 */
export function formatCurrency({ amount, language, subsidiary, options, }) {
    const locale = getLocale(language, subsidiary);
    const isRoundAmount = Number.isInteger(amount);
    const currencyString = Intl.NumberFormat(locale, {
        style: (options === null || options === void 0 ? void 0 : options.hideCurrencySymbol) ? 'decimal' : 'currency',
        currency: 'EUR',
        minimumFractionDigits: isRoundAmount ? 0 : 2,
        maximumFractionDigits: 2,
    }).format(amount);
    return isRoundAmount ? `${currencyString},-` : currencyString;
}
//# sourceMappingURL=formatCurrency.js.map